import Apps from './core';
import Helper, { AppCore } from './helper';
import { isMyBoboup } from '@/asset/js/utils';
// 注册login的钩子
import './login';
// 注册分享钩子
import './share';

// AppCore对外提供的方法
Helper.extend(AppCore, {
  /**
   * @name AppCore.getAppName
   * @param  {boolean} [getAll=false]  是否返回所有命中的环境名称
   * @return {string|string[]} 默认返回当前最为匹配的一个环境名称，如果getAll为true，则返回所有命中的环境名称，比如 ["weixin", "wap"]
   * @description 查询当前的环境名称，返回诸如 weixin、yixin 等字符串标识符，或 wap；
   * @function
   */
  getAppName(getAll) {
    const appNames = Apps.is();
    return getAll ? appNames : appNames[0];
  },
  /**
   * @name AppCore.findMethodOwner
   * @param  {string} method  要查询的方法名
   * @return {string} 返回指定方法名所属的环境
   * @description 查找命中的环境配置中，有配置方法的数据
   * @function
   */
  findMethodOwner(method) {
    return Apps.findMethodOwner(method);
  },
  /**
   * @privateEntry {boolean} [privateEntry=false] 是否注册到私有入口： AppCore[appName] - 私有接口即只存在于某个环境下
   * @param {string} appName 注册的环境标识，比如 weixin
   * @param {object} appConfig 注册的配置内容，其中<br>
   *                           appConfig.is 方法作为判断环境之用，不引用到任何入口<br>
   *                           appConfig.version 方法仅仅添加到私有入口中<br>
   *                           appConfig.ready 方法仅仅添加到私有入口中<br>
   *                           以 _ 开头的方法会被忽略<br>
   *                           非函数成员会被忽略<br>
   *                           其他方法的同名代理方法会被扩展到 AppCore 上<br>
   *                           如果privateEntry为true，则同步扩展到 AppCore[appName] 上
   * @description 注册一个App到AppCore
   */
  reg(privateEntry, name, config) {
    return Apps.reg(privateEntry, name, config);
  },
  /**
   * @name AppCore.setCacheIndex
   * @param {function} fn	cacheIndex会被当作参数传递给此函数，返回的数组作为新的cacheIndex
   * @description 调整cacheIndex的元素顺序
   * @function
   */
  setCacheIndex(fn) {
    return Apps.setCacheIndex(fn);
  }
});

Apps.reg('starwave', {
  // 私有核心方法，不暴露
  is(ua, os) {
    console.log(ua, 'ua')
    // 以 _mapp_/ 作为 bridge 标识检测环境，不限制具体 app 名称
    return ua.indexOf('_mapp_/') >= 0 || ua.indexOf('apptitle/hope') >= 0 || ua.indexOf('app_name/starwave') >= 0;
  },
  // 获取app的协议
  // iOS(starwave) → starwave://  Android(soulu) → soulu://
  getPrivateProto() {
    if (Helper.ua.indexOf('company/soulu') >= 0) {
      return 'soulu://';
    }
    return 'starwave://';
  },
  /**
   * @name  AppCore.caipiao.version
   * @description 从UA中获取客户端版本，如果非客户端，则返回0
   * @param  {boolean} [getMainVersion=false] 是否获取主版本号，默认获取build号
   * @return {number}  彩票App版本号
   * @function
   */
  version(getMainVersion) {
    let version = 0;
    let build = 0;
    // 匹配任意 company/X client/X 格式，不限制具体 app 名称
    if (
      /(?:company\/\S+\s+client\/\S+)(?:.*)\s+version\/([^\s]+)\s+versionint\/(\d+)/i.test(
        Helper.ua
      )
    ) {
      version = RegExp.$1;
      build = +RegExp.$2;
    }
    return getMainVersion ? version : build;
  },
  /**
   * @name AppCore.caipiao.ready
   * @description 彩票JS Bridge准备OK事件挂接
   * @param {function} fn 绑定的ready事件
   * @function
   */
  ready(fn) {
    // iOS - Hope
    if (window.HopeWebApi) {
      return fn(window.HopeWebApi, true);
    }
    // iOS - Lumos
    if (window.iOSJSApi) {
      return fn(window.iOSJSApi, true, true);
    }
    // Android - soulu / starwave
    if (window.AFJsApi) {
      return fn(window.AFJsApi);
    }
    if (window.soulu) {
      return fn(window.soulu);
    }
    const supportReady = true;
    if (supportReady) {
      document.addEventListener('LDMJsBridgeReady', () => {
        console.log(window.AFJsApi || window.soulu, 'JsBridgeReady');
        fn(window.AFJsApi || window.soulu);
      });
    } else {
      Helper.ready(() => fn(window.AFJsApi || window.soulu));
    }
  },

  // 简易url参数处理工具，仅内部使用
  _rmUrlPara(url, paraArr) {
    url = url.replace(/#.+$/, '');
    paraArr.forEach(key => {
      url = url.replace(new RegExp('(\\?|&)' + key + '=[^&|$]*', 'gi'), '$1');
    });
    return url.replace(/\?&/, '?').replace(/&{1,}/g, '&').replace(/&$/, '');
  }
});

/**
 * 兼容iOS多参数回调和Android单JSON字符串回调
 * iOS: callback(arg1, arg2, arg3) — 多参数分开传
 * Android: callback('{"key1":"val1","key2":"val2"}') — 统一封装为单个JSON字符串
 * @returns {object|null} 解析后的对象，null表示无需解析（iOS多参数模式）
 */
function _parseAppCallbackResult(firstArg, ...restArgs) {
  if (restArgs.some(arg => arg !== undefined && arg !== null)) {
    return null;
  }
  if (typeof firstArg === 'string') {
    try {
      const parsed = JSON.parse(firstArg);
      if (typeof parsed === 'object' && parsed !== null) {
        return parsed;
      }
    } catch (e) {}
  }
  return null;
}

/**
 * 容错提取 webEncryptUrl 回调结果。
 * native 返回的外层 JSON 中，appHeader 字段可能是一个 JSON 对象但其引号未正确转义
 * （如 "appHeader":"{"country":"SA",...}"），导致标准 JSON.parse 失败。
 *
 * 使用字段无关顺序的提取策略：
 * - authKey / url 的值不含双引号，用 [^"]* 精确匹配
 * - appHeader 内层对象用大括号深度计数提取，兼容嵌套和未转义引号
 */
function _extractEncryptResult(raw) {
  const result = { authKey: undefined, url: undefined, appHeader: undefined };
  if (typeof raw !== 'string') return result;

  const authKeyMatch = raw.match(/"authKey"\s*:\s*"([^"]*)"/);
  if (authKeyMatch) result.authKey = authKeyMatch[1];

  const urlMatch = raw.match(/"url"\s*:\s*"([^"]*)"/);
  if (urlMatch) result.url = urlMatch[1];

  const ahIdx = raw.indexOf('"appHeader"');
  if (ahIdx > -1) {
    const colonIdx = raw.indexOf(':', ahIdx + 11);
    if (colonIdx > -1) {
      let searchFrom = colonIdx + 1;
      while (searchFrom < raw.length && (raw[searchFrom] === ' ' || raw[searchFrom] === '"')) {
        searchFrom++;
      }
      if (raw[searchFrom] === '{') {
        let depth = 0;
        for (let i = searchFrom; i < raw.length; i++) {
          if (raw[i] === '{') depth++;
          else if (raw[i] === '}') {
            depth--;
            if (depth === 0) {
              result.appHeader = raw.substring(searchFrom, i + 1);
              break;
            }
          }
        }
      }
    }
  }
  return result;
}

/**
 * Android bridge 回调分发（FIFO 队列）。
 *
 * 背景：该 bridge 存在缺陷 —— native 通过 execGlobalCallback(id, data) 回调时，
 * 其数字 id 与 bridge 内部 mapp.callback 注册表的 key（形如 __MAPP_CALLBACK_N）
 * 不同步，导致 bridge 打印 "not found such callback"，业务回调收不到数据。
 *
 * 由于本项目所有"带回调的 invoke"都统一经过 _androidInvoke（其余 bridge 能力走
 * disPatchEvent / __fireCallback，不走 execGlobalCallback），execGlobalCallback 的
 * 每一次触发都必然对应一次 _androidInvoke。因此这里用 FIFO 队列自行分发，绕过
 * bridge 有缺陷的 id 匹配。
 */
const _androidCbQueue = [];
const ANDROID_INVOKE_TIMEOUT = 15000;
let _androidInvokeChain = Promise.resolve();
/** @type {boolean|null} null=未探测, false=客户端不支持 */
let _updateRedDotStatusSupported = null;

function _dispatchAndroidCallback(data) {
  const entry = _androidCbQueue.shift();
  if (entry && typeof entry.fn === 'function') {
    try {
      entry.fn(data);
    } catch (e) {
      console.error('[Bridge] Android 回调执行异常:', e);
    }
  } else {
    console.warn('[Bridge] execGlobalCallback 无匹配的待处理回调, data=', typeof data === 'string' ? data.substring(0, 80) : data);
  }
}

/**
 * Android bridge 回调机制：
 * 1. 提前初始化 window.mapp 确保 bridge 框架能正常建立回调系统
 * 2. 用 defineProperty 拦截 bridge 对 mapp 的覆写，保持引用可追踪
 * 3. 包裹 execGlobalCallback，在 bridge 原逻辑之后用 FIFO 队列兜底分发业务回调
 */
if (!window.mapp) window.mapp = {};
let _currentMapp = window.mapp;
Object.defineProperty(window, 'mapp', {
  get() { return _currentMapp; },
  set(val) {
    console.log('[Bridge] mapp被设置, keys:', val ? Object.keys(val).join(',') : 'null');
    if (val && typeof val.execGlobalCallback === 'function') {
      const origExec = val.execGlobalCallback;
      val.execGlobalCallback = function(...args) {
        const preview = typeof args[1] === 'string' ? args[1].substring(0, 80) : args[1];
        console.log('[Bridge] execGlobalCallback 被调用! id=', args[0], '| data=', preview);
        // 先执行 bridge 自身逻辑（找不到回调时其内部打印 "not found such callback"，无副作用）
        try {
          origExec.apply(this, args);
        } catch (e) {
          console.warn('[Bridge] 原 execGlobalCallback 执行异常:', e);
        }
        // FIFO 兜底分发到真正的业务回调，绕过 bridge 的 id 匹配缺陷
        _dispatchAndroidCallback(args[1]);
      };
    }
    if (val && typeof val.__fireCallback === 'function') {
      const origFire = val.__fireCallback;
      val.__fireCallback = function(...args) {
        console.log('[Bridge] __fireCallback 被调用! args:', JSON.stringify(args));
        return origFire.apply(this, args);
      };
    }
    if (val && typeof val.callback === 'function') {
      const origCb = val.callback;
      val.callback = function(...args) {
        console.log('[Bridge] mapp.callback 被调用! args:', JSON.stringify(args));
        return origCb.apply(this, args);
      };
    }
    _currentMapp = val;
  },
  configurable: true
});

/**
 * Android bridge 串行调用：同一时刻仅一个 invoke 在途，避免 FIFO 回调与并发请求错位。
 */
function _androidInvoke(method, ...argsWithCallback) {
  const fn = argsWithCallback[argsWithCallback.length - 1];
  const params = argsWithCallback.slice(0, -1);

  _androidInvokeChain = _androidInvokeChain
    .catch(() => {})
    .then(
      () =>
        new Promise(resolve => {
          let settled = false;
          let wrappedFn = null;
          let timer = null;

          const finish = data => {
            if (settled) return;
            settled = true;
            if (timer) clearTimeout(timer);
            try {
              fn(data);
            } catch (e) {
              console.error('[Bridge] Android 回调执行异常:', e);
            }
            resolve();
          };

          wrappedFn = data => finish(data);

          timer = setTimeout(() => {
            console.warn('[Bridge] _androidInvoke 超时:', method);
            const idx = _androidCbQueue.findIndex(entry => entry.fn === wrappedFn);
            if (idx >= 0) _androidCbQueue.splice(idx, 1);
            finish(undefined);
          }, ANDROID_INVOKE_TIMEOUT);

          _androidCbQueue.push({ method, fn: wrappedFn });
          console.log('[Bridge] _androidInvoke:', method, '| pending=', _androidCbQueue.length);

          if (!window.mapp?.invoke) {
            _androidCbQueue.pop();
            finish(undefined);
            return;
          }

          try {
            window.mapp.invoke('cmd', method, ...params, function () {});
          } catch (e) {
            console.error('[Bridge] _androidInvoke invoke 异常:', e);
            _androidCbQueue.pop();
            finish(undefined);
          }
        })
    );
}

Apps.reg('starwave', {
  report(result, callback) {
    console.log(result, 'result');
    // 参数result  ：json
    AppCore.starwave.ready((jsapi, isIos, isLumos) => {
      if (isIos) {
        if (isLumos) {
          jsapi?.common?.eventReport(result);
          return;
        }
        jsapi?.instance?.webReport(result);
        return;
      }
      jsapi?.cmd?.report(result);
    });
  },
  rechargeClose(result) {
    // 参数result  ： true ，false
    AppCore.starwave.ready((jsapi, isIos, isLumos) => {
      console.log('rechargeClose-inner')
      if (isIos) {
        if (isLumos) {
          jsapi.common.pageClose(result);
          return;
        }
        jsapi.instance.webClose(result);
        return;
      }
      jsapi.pay.close(result);
    });
  },
  getStatusBarHeight(platform) {
    return new Promise((reslove, reject) => {
      try {
        AppCore.starwave.ready((jsapi, isIos, isLumos) => {
          if (
            (jsapi.cmd.getStatusBarHeight && typeof jsapi.cmd.getStatusBarHeight === 'function') ||
            typeof jsapi?.instance?.getStatusBarHeight === 'function'
          ) {
            if (platform === 'android') {
              _androidInvoke('getStatusBarHeight', {}, (...args) => {
                const parsed = _parseAppCallbackResult(...args);
                const res = parsed
                  ? (parsed.statusBarHeight ?? parsed.height ?? Object.values(parsed)[0])
                  : args[0];
                if (res) {
                  console.log('androidBarHeight', res);
                  reslove(res);
                } else {
                  reject('');
                }
              });
            } else {
              let res = jsapi.instance.getStatusBarHeight();
              if (isLumos) {
                res = jsapi.common.getStatusBarHeight();
              }
              if (res) {
                console.log('iosBarHeight', res);
                reslove(res);
              } else {
                reject('');
              }
            }
          } else {
            reject('');
          }
        });
      } catch (error) {
        reject('');
      }
    });
  },
  goBack(obj) {
    AppCore.starwave.ready((jsapi, isIos, isLumos) => {
      console.log('goBack-inner')
      if (isIos) {
        if (isLumos) {
          jsapi.common.pageGoBack && jsapi.common.pageGoBack(obj);
          return;
        }
        jsapi.instance.webBack && jsapi.instance.webBack(obj);
        return;
      } else {
        console.log('isAndroid:');
        jsapi.cmd.goBack && jsapi.cmd.goBack(obj);
      }
    });
  },
  openUrl(obj) {
    // 参数result  ： true ，false
    AppCore.starwave.ready((jsapi, isIos) => {
      // console.log('rechargeClose')
      // if (isIos) {
      //   jsapi.common.pageClose(result);
      //   return;
      // }
      console.log(jsapi, 'jsapi');
      window?.AFJsApi?.cmd?.openUrl(obj);
      // jsapi?.cmd?.openurl(obj);
    });
  },
  disableSlideClose(result) {
    // 参数result  ： true ，false
    AppCore.starwave.ready((jsapi, isIos, isLumos) => {
      if (isIos) {
        if (isLumos) {
          jsapi.common.closeUserInteraction && jsapi.common.closeUserInteraction();
          return;
        }
        jsapi.instance.closeUserInteraction && jsapi.instance.closeUserInteraction();
        return;
      }
      jsapi.pay.disableInteractivePop && jsapi.pay.disableInteractivePop();
    });
  },
  webEncryptUrl(params = {}, url, callback) {
    console.log(params, url, '加密');
    return new Promise((resolve, reject) => {
      AppCore.starwave.ready((jsapi, isIos, isLumos) => {
        const onResult = (...args) => {
          console.log('[Bridge] webEncryptUrl onResult args.length=', args.length,
            '| types:', args.map(a => a === null ? 'null' : typeof a).join(','),
            '| preview:', args.map(a => typeof a === 'string' ? a.substring(0, 60) : a).join(' | '));
          let authKey, encryptedUrl, appHeader;

          const defined = args.filter(a => a !== undefined && a !== null);

          if (defined.length >= 2) {
            // Android 多参数回调（理论上不应出现，保留作兜底）
            authKey = args[0];
            encryptedUrl = args[1];
            appHeader = typeof args[2] === 'object' ? args[2] : undefined;
          } else if (defined.length === 1) {
            const first = args[0];
            if (first && typeof first === 'object') {
              authKey = first.authKey;
              encryptedUrl = first.url;
              appHeader = first.appHeader;
            } else if (typeof first === 'string') {
              try {
                const parsed = JSON.parse(first);
                if (parsed && typeof parsed === 'object') {
                  // 回调错位时可能收到 API 明文 { code, body }，不能当作加密结果
                  if (parsed.body !== undefined && parsed.code !== undefined && !parsed.url && !parsed.authKey) {
                    console.warn('[Bridge] webEncryptUrl 收到 API 明文响应，疑似回调错位');
                    reject('Failed to encrypt URL');
                    return;
                  }
                  authKey = parsed.authKey;
                  encryptedUrl = parsed.url;
                  appHeader = parsed.appHeader;
                }
              } catch (e) {
                const extracted = _extractEncryptResult(first);
                authKey = extracted.authKey;
                encryptedUrl = extracted.url;
                appHeader = extracted.appHeader;
              }
            }
          }

          if (appHeader && typeof appHeader === 'object') {
            try { appHeader = JSON.stringify(appHeader); } catch (e) {}
          }

          console.log('[Bridge] webEncryptUrl parsed:', {
            hasAuthKey: !!authKey,
            hasUrl: !!encryptedUrl,
            hasAppHeader: !!appHeader,
            urlPreview: encryptedUrl ? String(encryptedUrl).substring(0, 60) : null
          });

          if (encryptedUrl) {
            if (typeof callback === 'function') {
              callback(authKey, encryptedUrl);
            }
            resolve({ authKey, encryptedUrl, appHeader });
          } else {
            console.error('[Bridge] webEncryptUrl: encryptedUrl 为空, raw args:', JSON.stringify(args).substring(0, 300));
            reject('Failed to encrypt URL');
          }
        };
        if (isIos) {
          // iOS 使用原始具名参数回调，与 Android 通用路径完全隔离
          const iosCallback = (authKey, encryptedUrl, appHeader) => {
            if (encryptedUrl) {
              console.log('iosCallback', authKey, encryptedUrl, appHeader);
              if (typeof callback === 'function') {
                callback(authKey, encryptedUrl);
              }
              resolve({ authKey, encryptedUrl, appHeader });
            } else {
              reject('Failed to encrypt URL');
            }
          };
          try {
            if (isLumos && typeof jsapi.common?.webEncryptUrl === 'function') {
              jsapi.common.webEncryptUrl(params, url, iosCallback);
            } else {
              jsapi.instance.webEncryptUrl(params, url, iosCallback);
            }
          } catch (e) {
            console.error('[Bridge] webEncryptUrl iOS 调用异常:', e);
            reject('webEncryptUrl call failed: ' + e.message);
          }
        } else {
          _androidInvoke('webEncryptUrl', JSON.stringify(params), url, onResult);
        }
      });
    });
  },
  webDecretedData(key, data) {
    return new Promise((resolve, reject) => {
      AppCore.starwave.ready((jsapi, isIos, isLumos) => {
        const onResult = (...args) => {
          console.log('[Bridge] webDecretedData onResult args.length=', args.length,
            '| type:', typeof args[0],
            '| preview:', typeof args[0] === 'string' ? args[0].substring(0, 80) : args[0]);
          const parsed = _parseAppCallbackResult(...args);
          const raw = parsed ?? args[0];
          if (typeof raw === 'string' && raw.length > 0) {
            resolve(raw);
          } else if (raw && typeof raw === 'object') {
            resolve(JSON.stringify(raw));
          } else {
            console.error('[Bridge] webDecretedData: 解密结果为空, raw args:', args);
            reject('Decryption failed');
          }
        };
        if (isIos) {
          try {
            if (isLumos && typeof jsapi.common?.webDecretedData === 'function') {
              jsapi.common.webDecretedData(key, data, onResult);
            } else {
              jsapi.instance.webDecretedData(key, data, onResult);
            }
          } catch (e) {
            console.error('[Bridge] webDecretedData iOS 调用异常:', e);
            reject('webDecretedData call failed: ' + e.message);
          }
        } else {
          _androidInvoke('webDecretedData', key, data, onResult);
        }
      });
    });
  },
  getWebNetToken() {
    return new Promise((resolve, reject) => {
      AppCore.starwave.ready((jsapi, isIos) => {
        const onResult = (...args) => {
          const parsed = _parseAppCallbackResult(...args);
          const token = parsed
            ? (parsed.token ?? Object.values(parsed)[0])
            : args[0];
          if (token) {
            resolve(token);
          } else {
            reject('Failed to get token');
          }
        };
        if (isIos) {
          jsapi.instance.getWebNetToken(onResult);
        } else {
          _androidInvoke('getWebNetToken', onResult);
        }
      });
    });
  },
  updateRedDotStatus(status) {
    // status 传false清除提现红点，传true,获取红点状态
    if (_updateRedDotStatusSupported === false) {
      return Promise.resolve(false);
    }

    return new Promise(resolve => {
      let settled = false;
      const finish = value => {
        if (settled) return;
        settled = true;
        resolve(!!value);
      };

      const timer = setTimeout(() => finish(false), 5000);

      try {
        AppCore.starwave.ready((jsapi, isIos) => {
          const onResult = (...args) => {
            clearTimeout(timer);
            const parsed = _parseAppCallbackResult(...args);
            const raw = parsed ?? args[0];
            const rawText = typeof raw === 'string' ? raw : '';
            const errorText = parsed?.error || parsed?.message || '';

            if (/invalid/i.test(rawText) || /invalid/i.test(String(errorText))) {
              _updateRedDotStatusSupported = false;
              console.warn('[Bridge] updateRedDotStatus 无效响应:', rawText || errorText);
              finish(false);
              return;
            }

            _updateRedDotStatusSupported = true;
            const shouldShowRedDot = parsed
              ? (parsed.shouldShowRedDot ?? parsed.status ?? Object.values(parsed)[0])
              : args[0];
            finish(shouldShowRedDot);
          };

          if (isIos) {
            if (typeof jsapi?.instance?.updateRedDotStatus === 'function') {
              jsapi.instance.updateRedDotStatus(status, onResult);
              return;
            }
            _updateRedDotStatusSupported = false;
            finish(false);
            return;
          }

          const cmdFn = jsapi?.cmd?.updateRedDotStatus;
          if (typeof cmdFn === 'function') {
            cmdFn(status, onResult);
            return;
          }

          // 未注册的方法不走 mapp.invoke，避免 Native 弹出 invalidAction
          _updateRedDotStatusSupported = false;
          finish(false);
        });
      } catch (e) {
        clearTimeout(timer);
        console.warn('[Bridge] updateRedDotStatus 调用异常:', e);
        finish(false);
      }
    });
  }
});

Apps.regHook('updateRedDotStatus', {
  defaultFn() {
    return Promise.resolve(false);
  }
});

window.AppCore = AppCore;
export default AppCore;
